module.exports = __webpack_public_path__ + "img/program3.d32641c4.png";